const KEY = "artevent_selection";

export function getCart() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export function addToCart(item) {
  const cart = getCart();
  const choicesKey = (i) => JSON.stringify([...(i.option_choice_ids || [])].sort());
  const existing = cart.find((i) => i.slug === item.slug && i.variant_id === item.variant_id && choicesKey(i) === choicesKey(item));
  if (existing) {
    existing.qty += item.qty;
  } else {
    cart.push(item);
  }
  localStorage.setItem(KEY, JSON.stringify(cart));
  return cart;
}

export function updateCartItem(slug, qty) {
  const cart = getCart().map((i) => (i.slug === slug ? { ...i, qty: Math.max(1, qty) } : i));
  localStorage.setItem(KEY, JSON.stringify(cart));
  return cart;
}

export function removeFromCart(slug) {
  const cart = getCart().filter((i) => i.slug !== slug);
  localStorage.setItem(KEY, JSON.stringify(cart));
  return cart;
}

export function clearCart() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(KEY + "_idem");
  localStorage.removeItem(KEY + "_promo");
}

export function cartCount() {
  return getCart().reduce((sum, i) => sum + i.qty, 0);
}

export function getCartMode() {
  return localStorage.getItem(KEY + "_mode") || "retrait";
}

export function setCartMode(mode) {
  localStorage.setItem(KEY + "_mode", mode);
}

export function getIdempotencyKey() {
  let key = localStorage.getItem(KEY + "_idem");
  if (!key) {
    key = crypto.randomUUID();
    localStorage.setItem(KEY + "_idem", key);
  }
  return key;
}

export function getPromoCode() {
  return localStorage.getItem(KEY + "_promo") || "";
}

export function setPromoCode(code) {
  if (code) localStorage.setItem(KEY + "_promo", code);
  else localStorage.removeItem(KEY + "_promo");
}
